import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentTemplateListSelectContentTemplate from "@Broker/@HandlebarsTemplates/clients/applications/documents/document-template-list-control/_document-template-list-select-content.hbs";
import Select2 from "@Shared/components/inputs/select2";
import { mapState } from "vuex";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RequestListSelect",
  components: {
    Select2
  },
  props: {
    selectedRequestList: {
      type: String,
      required: true
    },
    requestLists: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("DocumentsStore", {
    DRAFT_TEMPLATE_NAME(state) {
      return state.DRAFT_TEMPLATE_NAME;
    }
  })), {}, {
    options() {
      return {
        dropdownParent: "#request-list-select-container",
        closeOnSelect: true,
        templateResult: state => $(DocumentTemplateListSelectContentTemplate(state)),
        allowClear: false,
        sorter: data => {
          const dataCopy = cloneDeep(data);
          const draftTemplateIndex = _findIndexInstanceProperty(data).call(data, ({
            id
          }) => id === this.DRAFT_TEMPLATE_NAME);
          const [draftItem] = _spliceInstanceProperty(dataCopy).call(dataCopy, draftTemplateIndex, 1);
          return [draftItem, ..._sortInstanceProperty(dataCopy).call(dataCopy, (a, b) => a.text.localeCompare(b.text))];
        },
        language: {
          noResults: () => `
            <div class="d-flex flex-column bold clickable" id="no-results-btn">
                <span class="grey-text font-italic font-weight-normal">
                ${this.$t("global.phrases.nothingToShowHere")} :(
                </span>
              </div>
          `
        },
        escapeMarkup: markup => markup
      };
    },
    requestListsValues() {
      return _Object$values(this.requestLists.byId);
    }
  }),
  methods: {
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, ({
        name,
        draft
      }) => {
        return {
          id: name,
          text: draft ? this.$t("documents.draftTemplate") : name
        };
      });
    },
    handleChange({
      id
    }) {
      this.$emit("change", {
        requestListName: id
      });
    }
  }
});